import { render, staticRenderFns } from "./LabTest.vue?vue&type=template&id=5f9030bf&scoped=true&"
import script from "./LabTest.vue?vue&type=script&lang=js&"
export * from "./LabTest.vue?vue&type=script&lang=js&"
import style0 from "./LabTest.vue?vue&type=style&index=0&id=5f9030bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9030bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
